import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau2 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17967" data-mp="z6pyknkjewa2">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17968" data-mp="1cwjlv1ge98ho"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17969" data-mp="18x10k4knuveb">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17970" data-mp="l5di8b1gssnn">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17971" data-mp="l7zz51a8wkij">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17972" data-mp="u7wicndv8r67">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17973" data-mp="25lh3r3gp139w">
          <div className="text-left" data-id="element-17974" data-mp="20m47xt7uglv6">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17975" data-mp="3nut1faim9m8e">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17976" data-mp="347bk6ojbyf77">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17977" data-mp="393af6uz5yvgl">
        <div className="max-w-4xl mx-auto" data-id="element-17978" data-mp="3e355oxf11j14">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17979" data-mp="3ivg601doj6u7">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17980" data-mp="2lfj0jkq5i6c5">
            Dr. Reed: How To Avoid 90% of GLP-1 Weight Loss Plateaus — Without
            Increasing Your Dose.
          </h1>
          <p className="text-sm sm:text-base text-gray-500 italic mb-6" data-id="element-17981" data-mp="2ecud7p9x3ya4">
            (From a Metabolic Specialist Who Spent 18 Months Trying To Solve Her
            Own Plateau)
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-17982" data-mp="2n4nzztg1i585">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17983" data-mp="1zfbogmx8pl2o">
              <img src="https://cdn.magicpatterns.com/uploads/njKHWtEUNXzL7WtDqVKiu5/pasted-image.jpg" alt="Dr. Patricia Reed" className="w-full h-full object-cover" data-id="element-17984" data-mp="1ve9o22rl72z4" />
            </div>
            <div className="flex-1" data-id="element-17985" data-mp="29beuw4z4k5vf">
              <div className="flex items-center gap-2 mb-2" data-id="element-17986" data-mp="24eeua9l1nvbp">
                <span className="text-base font-medium text-gray-900" data-id="element-17987" data-mp="3ksy0u543amxo">
                  Written by Dr. Patricia Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-17988" data-mp="3fss62g2iwkbd" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17989" data-mp="11lkj587v1w01">
                Verified Metabolic Health Specialist, Cedar Sinai Medical Center
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-17990" data-mp="16j2lugvabezl">
                <div className="flex items-center gap-1" data-id="element-17991" data-mp="smyviynj7qse">
                  <ClockIcon className="h-4 w-4" data-id="element-17992" data-mp="xjz1zaoamvk1" />
                  <span data-id="element-17993" data-mp="xml5mz82cqwz">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17994" data-mp="1lb4djdn7b1oj">
                  <EyeIcon className="h-4 w-4" data-id="element-17995" data-mp="1pbn7peckgjtw" />
                  <span data-id="element-17996" data-mp="1pad82kq2f3l5">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17997" data-mp="1bjzyyf1ftiu8">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17998" data-mp="1gjcwputukabl" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-17999" data-mp="246ugp46ve440">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18000" data-mp="kdtaub7cnggb">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18001" data-mp="fdykq9veeuwb">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-18002" data-mp="6elctlmxaedp"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-18003" data-mp="6fmonsbrj4wh">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance — it has hit a "stress
            threshold." Here's how to break through it, or prevent it from ever
            happening.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18004" data-mp="pc4icfa69evd">
            <div className="mb-1 flex items-center" data-id="element-18005" data-mp="1mtmj4nrua2cc">
              <span className="font-medium mr-2" data-id="element-18006" data-mp="1i1bifip9yciq">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18007" data-mp="1pearifd9rdbw">
              <span className="font-medium mr-2" data-id="element-18008" data-mp="1ubawso2aoc1y">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau2;